module.exports = __webpack_public_path__ + "img/bqbh.d2bc4535.png";